import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { Sgke012aResponseSearchResultList } from 'sg-api';

@Component({
  selector: 'app-sgke010d-search-result',
  templateUrl: './sgke010d-search-result.component.html',
  styleUrl: './sgke010d-search-result.component.scss'
})
export class Sgke010dSearchResultComponent implements OnInit, OnDestroy {
  /** 詳細画面フラグ */
  @Input() isDetail = false;
  /** 表データ */
  @Input() responseList: Array<Sgke012aResponseSearchResultList>;
  /** データソース */
  dataSource: MatTableDataSource<Sgke012aResponseSearchResultList>;
  /** ソート */
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** ダブルクリックEmitter */
  @Output() onDblClickFlgEmitter = new EventEmitter();
  /**
   *
   * 最小幅設定
   * @readonly
   * @type {string}
   * @memberof Sgke010dSearchResultComponent
   */
  get minWidth(): string {
    return this.isDetail ? '1020px' : '2090px'
  }

  /**
   * 画面カラム名設定
   * @readonly
   * @type {string[][]}
   * @memberof Sgke010dSearchResultComponent
   */
  get displayedColumnsCol(): string[][] {
    // 詳細画面でのカラム分割
    const columns: string[][] = [[
      'kinkoOccurrenceDate',
      'paymentContractNo',
      'visitName',
      'receiveMoneyNo',
      'rcvmnyDate',
      'inmny',
      'remny',
      'jikaiClaimPlndate',
      'rcvmnyKeitai',
      'rcvmnyFclt',
    ], [
      'kinkoSts',
      'kinkoReason',
      'kakuhoNotarrive',
      'kouzaReg',
      'effectCtrUmu',
      'rpaytoConfirmationrequestDate',
      'kinkoTrnDate',
      'kinkoTrnTntsh',
    ]];
    // 詳細画面の場合は分割した配列を、照会画面の場合は結合した配列を格納
    this._displayedColumnsCol ??= this.isDetail ?
      columns :
      [columns.reduce((p, c) => p.concat(c), [])];
    // 格納した配列を返す
    return this._displayedColumnsCol;
  }
  private _displayedColumnsCol: string[][] = null;

  /** コンストラクタ */
  constructor(
    private router: Router,
    public timeApiService: TimeApiService,
  ) {
  }
  /**
   * 初期化処理
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke012aResponseSearchResultList>(this.responseList);
  }
  /**
   * View変更時実施処理
   */
  ngAfterViewChecked(): void {
    this.dataSource.sort ??= this.sort;
  }

  /** 購読を停止する処理 */
  ngOnDestroy() {
    this.onDestroy$.next();
  }
  /**
   * 行ダブルクリック時
   * @param row 行
   * @param event マウスイベント
   */
  onClickRow(row: Sgke012aResponseSearchResultList, event?: MouseEvent) {

    this.onDblClickFlgEmitter.emit();
    if (!this.isDetail) {
      this.router.navigate(['sgke/sgke020d', {
        kinkoMno: row.kinkoMno || "",
        kinkoRrkno: row.kinkoRrkno || ""
      }]);
    }
    event?.stopPropagation();
  }

}
